import { computed, observable } from "mobx";
import type { IBankAccount } from "./types";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class DomesticBankAccountResponse {
  @observable
  accountNumber!: string;

  @observable
  bankCode!: string;
}

export default class DomesticBankAccount extends DomesticBankAccountResponse implements IBankAccount {
  @computed
  get bank() {
    return this.bankCode;
  }
}
